module.exports = __webpack_public_path__ + "media/images/pic/home/pride-cloud-62d802f2d06f6a0026ef7ec27040d9f5.svg";